/**
 * Person profile + event property keys (aligned with Flutter `TrackingKeys`).
 */
export const TrackingKeys = {
    kCompanyGroupId: 'company_group_id',

    // PostHog person profile fields (Flutter userTrackingProperties)
    kCreatedAt: 'created_at',
    kAccountType: 'account_type',
    kPlanType: 'plan_type',
    kSubscriptionStatus: 'subscription_status',
    kSubscriptionModel: 'subscription_model',
    kSubscriptionPackage: 'subscription_package',
    kSubscriptionPackageValidity: 'subscription_package_validity',
    kTotalBookings: 'total_bookings',
    kFirstBookingDate: 'first_booking_date',
    kLastBookingDate: 'last_booking_date',
    kIsFirstBookingCompleted: 'is_first_booking_completed',
    kIdentity: 'identity',
    kIsHost: 'is_host',
    kDeskPassesConsumed: 'desk_passes_consumed',
    kDeskPassesLimit: 'desk_passes_limit',
    kMeetingRoomPassesConsumed: 'meeting_room_passes_consumed',
    kMeetingRoomPassesLimit: 'meeting_room_passes_limit',
    kEmail: 'email',
    kPhone: 'phone',
    kLanguage: 'language',
    kMsgEmail: 'msg-email',
    kMsgPush: 'msg-push',
    kMsgSms: 'msg-sms',
    /** PostHog person keys (capitalized — same as mobile / CleverTap). */
    kCity: 'City',
    kCountry: 'Country',
    kLocation: 'Location',
    kTz: 'Tz',
    kNearestWorkspace: 'Nearest Workspace'
} as const;

/** Keys stored on events but not sent as PostHog person properties. */
export const TRACKING_EVENT_CONTEXT_KEYS = new Set([
    'user_id',
    'uuid',
    'environment',
    'app_version',
    'currency',
    'timestamp',
    'screen_url'
]);

export const POSTHOG_PERSON_PROFILE_KEYS: string[] = [
    'name',
    'first_name',
    'last_name',
    TrackingKeys.kCreatedAt,
    TrackingKeys.kAccountType,
    TrackingKeys.kPlanType,
    TrackingKeys.kSubscriptionStatus,
    TrackingKeys.kSubscriptionModel,
    TrackingKeys.kSubscriptionPackage,
    TrackingKeys.kSubscriptionPackageValidity,
    TrackingKeys.kTotalBookings,
    TrackingKeys.kFirstBookingDate,
    TrackingKeys.kLastBookingDate,
    TrackingKeys.kIsFirstBookingCompleted,
    TrackingKeys.kIdentity,
    TrackingKeys.kIsHost,
    TrackingKeys.kDeskPassesConsumed,
    TrackingKeys.kDeskPassesLimit,
    TrackingKeys.kMeetingRoomPassesConsumed,
    TrackingKeys.kMeetingRoomPassesLimit,
    TrackingKeys.kCompanyGroupId,
    TrackingKeys.kEmail,
    TrackingKeys.kPhone,
    TrackingKeys.kLanguage,
    TrackingKeys.kMsgEmail,
    TrackingKeys.kMsgPush,
    TrackingKeys.kMsgSms,
    TrackingKeys.kCity,
    TrackingKeys.kCountry,
    TrackingKeys.kLocation,
    TrackingKeys.kTz,
    TrackingKeys.kNearestWorkspace
];
